export const NotFoundPage = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <div className="text-center max-w-md mx-auto p-8">
      <h1 className="text-6xl font-bold text-gray-200 mb-4">404</h1>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Page Not Found</h2>
      <p className="text-gray-600 mb-8">The page you're looking for doesn't exist or may have been moved.</p>
      <a
        href="/"
        className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium">
        ← Go Home
      </a>
    </div>
  </div>
)

export const RouterErrorBoundary = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <div className="text-center max-w-md mx-auto p-8">
      <h1 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h1>
      <p className="text-gray-600 mb-8">We encountered an error while loading this page. Please try again.</p>
      <button
        onClick={() => window.location.reload()}
        className="inline-block bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors font-medium">
        Reload Page
      </button>
    </div>
  </div>
)
